import React, { useMemo } from 'react';

const Badge = ({ percentage }) => (
	<span className={`badge ${percentage <= 80 ? 'badge-danger' : 'badge-success'}`}>
		{percentage}%
	</span>
);

const CardItem = ({ title, total, percentage }) => (
	<div className="col-sm-6">
		<div className="card">
			<div className="card-body">
				<h4 className="card-title mt-2">{title}</h4>
				<div className="d-flex align-items-center mt-3 mb-2">
					<h2 className="fs-38 mb-0 me-3">{total}</h2>
					<Badge percentage={percentage} />
				</div>
			</div>
		</div>
	</div>
);

const CardBlog = (props) => {
	const {
		totalRequestCompleted,
		totalMivCompleted,
		totalTransferCompleted,
		totalMrvcompleted,
		totalMtncompleted,
		requestTotal,
		transferTotal,
		mivTotal,
		MtnTotal,
		MrvTotal,
	} = props;

	// Memoize percentage calculations and card data
	const data = useMemo(() => {
		const safeDivision = (numerator, denominator) =>
			denominator > 0 ? Math.round((numerator * 100) / denominator) : 0;

		return [
			{
				title: 'Request Voucher Completed (RV)',
				total: totalRequestCompleted,
				percentage: safeDivision(totalRequestCompleted, requestTotal),
			},
			{
				title: 'Material Invoice Voucher (MIV)',
				total: totalMivCompleted,
				percentage: safeDivision(totalMivCompleted, mivTotal),
			},
			{
				title: 'Transfer Order',
				total: totalTransferCompleted,
				percentage: safeDivision(totalTransferCompleted, transferTotal),
			},
			{
				title: 'Material Transfer Note (MTN)',
				total: totalMtncompleted,
				percentage: safeDivision(totalMtncompleted, MtnTotal),
			},
			{
				title: 'Material Received Voucher (MRV)',
				total: totalMrvcompleted,
				percentage: safeDivision(totalMrvcompleted, MrvTotal),
			},
			{
				title: 'Fabrication',
				total: totalMrvcompleted, // Example: Replace with actual fabrication data if available
				percentage: safeDivision(totalMrvcompleted, MrvTotal), // Adjust if fabrication uses a different metric
			},
		];
	}, [
		totalRequestCompleted,
		totalMivCompleted,
		totalTransferCompleted,
		totalMrvcompleted,
		totalMtncompleted,
		requestTotal,
		transferTotal,
		mivTotal,
		MtnTotal,
		MrvTotal,
	]);

	return (
		<div className="row">
			<div className="col-xl-12">
				<div className="card coin-card">
					<h2 className="text-center text-white card-title pt-3 pb-2">
						Summary of Completed Requests
					</h2>
				</div>
			</div>
			{data.map((item, index) => (
				<CardItem
					key={index}
					title={item.title}
					total={item.total}
					percentage={item.percentage}
				/>
			))}
		</div>
	);
};

export default React.memo(CardBlog);
